import pathRouts from '../../shared/enums/pathRoute';
import iconsList from '../../shared/components/ui/icons/iconsList';

const MENUTABS = [
    { route: pathRouts.HOME, icon: iconsList.home, titleKey: 'homePage' },
    { route: pathRouts.MYLEARNING, icon: iconsList.myLearning, titleKey: 'myClasses' },
    { route: pathRouts.USEFULTOOLS, icon: iconsList.usefulTools, titleKey: 'usefulTools' },
    { route: pathRouts.CALENDAR, icon: iconsList.calendar, titleKey: 'calendar' },
    { route: pathRouts.DISCOVERY, icon: iconsList.discovery, titleKey: 'discovery' },
    { route: pathRouts.PROFFESSIONALDEVELOPMENT, icon: iconsList.professionalDevelopment, titleKey: 'ProfessionalDevelopment' }
];

export const tabRoutes = MENUTABS.map(tab => `/${tab.route}`);

export const getMenuTabByPath = (pathname) => MENUTABS.find(tab => `/${tab.route}` === pathname);

const normalizeTabRoute = (route) => (route.startsWith('/') ? route : `/${route}`);

export const isMenuRoute = (pathname, dynamicTabs = []) =>
    [...MENUTABS, ...dynamicTabs].some(tab => normalizeTabRoute(tab.route) === pathname);

export default MENUTABS;
